import { get } from 'lodash';
import React, { useMemo } from 'react';
import { useQuery } from 'react-apollo';
import getGqlOperationName from '../../../../../utils/getGqlOperationName';
import { SelectionMode } from '../../../../dataViews/DynamicTree';
import Error from '../../../../utils/Error';
import EntityField from '../../internal/EntityField';
import TreeSelectorFieldContent from './TreeSelectorFieldContent';
import useT from '../../../../utils/Translations/useT';
export default function TreeSelectorField({ name, label, gql, gqlVariables = {}, tree = 'TreeSelectorField', gqlSkip = false, selectionMode = SelectionMode.MULTI, plugins = {}, adapter = {}, required = false, disabled = false, cookModels, gqlFetchPolicy = 'no-cache', hasSpinner = true, hasTitle = false, formElement = true, ...props }) {
    const t = useT();
    const queryRes = useQuery(gql, {
        variables: gqlVariables,
        skip: gqlSkip,
        fetchPolicy: gqlFetchPolicy,
    });
    const models = useMemo(() => {
        const data = get(queryRes, `data.${getGqlOperationName(gql)}`, []);
        return cookModels ? cookModels(data) : data;
    }, [gql, queryRes, cookModels]);
    const _label = useMemo(() => ((queryRes === null || queryRes === void 0 ? void 0 : queryRes.loading) && !hasSpinner ? t('loading...') : label), [t, queryRes, label, hasSpinner]);
    if (queryRes.error) {
        return <Error error={queryRes.error}/>;
    }
    return (<EntityField disabled={disabled} name={name} required={required} {...props}>
      {(isEditing, field, { required, disabled }) => (<TreeSelectorFieldContent adapter={adapter} field={field} formElement={formElement} hasTitle={hasTitle} isDisabled={disabled || (!hasSpinner && (queryRes === null || queryRes === void 0 ? void 0 : queryRes.loading))} isEditing={isEditing} isLoading={queryRes.loading} isRequired={required} label={_label} models={models} name={name} plugins={plugins} selectionMode={selectionMode} tree={tree} {...props}/>)}
    </EntityField>);
}
